import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { siteUrl } from "../config/urls";

const SiteRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    window.location.replace(siteUrl(`${location.pathname}${location.search}${location.hash}`));
  }, [location.hash, location.pathname, location.search]);

  return null;
};

export default SiteRedirect;
